import { useMsal } from '@azure/msal-react'
import LockClockIcon from '@mui/icons-material/LockClock'
import { Box, Button, Card, CardContent, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { loginRequest } from '../authConfig'
import { logger } from '../utils/logger'

const SessionExpiredPage = () => {
  const theme = useTheme()
  const { instance } = useMsal()
  const { t } = useTranslation()

  const handleSignIn = () => {
    instance.loginRedirect(loginRequest).catch((e: unknown) => logger.error('Login redirect error', e))
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <Card elevation={6} sx={{ maxWidth: 500, width: '100%', borderTop: `6px solid ${theme.palette.primary.main}` }}>
        <CardContent sx={{ padding: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <LockClockIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mr: 2 }} />
            <Typography variant="h5" component="h1" sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}>
              {t('sessionExpired.title')}
            </Typography>
          </Box>
          <Typography sx={{ mb: 3 }}>{t('sessionExpired.description')}</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="contained" color="primary" onClick={handleSignIn} sx={{ px: 4, py: 1.5 }}>
              {t('sessionExpired.signIn')}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default SessionExpiredPage
